import styled, { css, keyframes } from "styled-components";
import { CheckoutButton } from "../styles";

const appear = keyframes`
    0% {
      opacity: 0;
      transform: scale(0.5);
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
`;

export const FinishedPurchase = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  gap: 24px;
  margin: 0 auto;
  margin-bottom: 24px;
  width: fit-content;

  animation: ${appear} 1s cubic-bezier(0, 0, 0.2, 1) forwards;
`;

export const FinishedPurchaseText = styled.p`
  line-height: 100%;
  letter-spacing: 0%;
  ${({ type }) => {
    return type === "title"
      ? css`
          font-family: "Open Sans", sans-serif;
          font-weight: 700;
          font-size: 20px;
          text-align: center;
          margin-bottom: 8px;
          color: #020618;
        `
      : css`
          font-family: "Inter", sans-serif;
          font-weight: 400;
          font-size: 16px;
          color: #314158;
          margin-bottom: 0px;
        `;
  }}
`;

export const Flex = styled.div`
  display: flex;
  align-items: ${({ items }) => items ?? "center"};
  justify-content: ${({ justify }) => justify ?? "center"};
  flex-direction: ${({ direction }) => direction ?? "row"};
  flex-wrap: ${({ wrap }) => wrap ?? "nowrap"};
  gap: ${({ gap }) => gap ?? "0px"};
  padding-top: ${({ paddingTop }) => paddingTop ?? "0px"};
  padding-bottom: ${({ paddingBottom }) => paddingBottom ?? "0px"};

  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `};

  ${({ flex }) =>
    flex &&
    css`
      flex: 1;
    `};

  ${({ full }) =>
    full &&
    css`
      width: 100%;
    `};

  ${({ mb }) =>
    mb &&
    css`
      margin-bottom: ${mb};
    `};
`;

export const Finished = styled.div`
  width: 115px;
  height: 115px;

  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;

  @keyframes ping {
    75%,
    100% {
      transform: scale(1.25);
      opacity: 0;
    }
  }

  @keyframes appear {
    0% {
      opacity: 0;
      transform: scale(0.5);
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  &::after {
    content: "";
    background-color: #f1f5f9;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;

    animation: ping 1.5s 3s cubic-bezier(0, 0, 0.2, 1) forwards,
      ${appear} 1s 4.5s cubic-bezier(0, 0, 0.2, 1) forwards,
      ping 1.5s 5.5s cubic-bezier(0, 0, 0.2, 1) forwards,
      ${appear} 1s 7s cubic-bezier(0, 0, 0.2, 1) forwards;
  }

  svg {
    position: relative;
    z-index: 10;
  }
`;

export const Summary = styled.div`
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 24px;
  background-color: #fff;
  display: grid;
  gap: 16px;

  animation: ${appear} 1s cubic-bezier(0, 0, 0.2, 1) forwards;
`;

export const SummaryCategory = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Divider = styled.div`
  width: 100%;
  border: 1px solid #e2e8f0;
`;

export const FooterButton = styled(CheckoutButton)`
  padding: 0px;
  height: 37px;
  min-width: 203px;
  max-width: calc(203px + 32px);
  padding: 0px 16px;
  gap: 2.5px;

  box-shadow: 0px 1px 2px 0px #19191c0a;

  &:hover {
    box-shadow: 0px 1px 12px rgba(25, 25, 28, 0.2);
  }

  ${({ print }) =>
    print &&
    css`
      border-color: transparent;
      background-color: #fff;
      color: #002244;
      box-shadow: none;

      &:hover,
      &:focus {
        color: #002244;
        background-color: #fff;
        /* border-color: #002244;*/
        border-color: transparent;
      }
    `}
`;
